/*
  getNodesThatCollapseForcefully.js
*/

/**
 * Returns a set of nodes that would be collapsed as a consequence of another node being collapsed.
 * 
 * Includes all nodes in the direction of the child nodes.
 * 
 * Based on "getVisibleGraphData.js" algorithm.
 */
export default function getNodesThatCollapseForcefully(graphData, node) {

  const hideNodes = new Set();

  // Get parent and child edges.

  const parentMap = new Map();
  const childMap = new Map();
  for (const link of graphData.links) {

    const tSet = childMap.get(link.source) || new Set();
    tSet.add(link.target);
    childMap.set(link.source, tSet);

    const sSet = parentMap.get(link.target) || new Set();
    sSet.add(link.source);
    parentMap.set(link.target, sSet);

  }

  // Get child nodes.
  const childNodes = childMap.get(node);
  if (!childNodes?.size) {
    return hideNodes;
  }

  // Visit each child node with DFS, ignoring the initial node.
  // Beyond the initial child nodes, visit both parent and child nodes.
  const visited = new Set([node]);
  function visit(nd) {

    // Check if this node has been visited already.
    if (!visited.has(nd)) {
      visited.add(nd);
      hideNodes.add(nd);

      // Visit parent nodes.
      const parentNodes = parentMap.get(nd);
      if (parentNodes) {
        for (const nd of parentNodes) {
          visit(nd);
        }
      }

      // Visit child nodes.
      const childNodes = childMap.get(nd);
      if (childNodes) {
        for (const nd of childNodes) {
          visit(nd);
        }
      }
    }
  }

  for (const nde of childNodes) {
    visit(nde);
  }

  return hideNodes;

}
